module.exports = __webpack_public_path__ + "img/logo.299579f9.png";